module.exports = __webpack_public_path__ + "img/widgetmapmockup.b30e0e63.png";